'use client';

import { useGaSignUpOnce } from '@hooks/useGaSignUpOnce';

/**
 * @description Mount this once in a shared layout to emit GA4 sign_up after registration redirect.
 */
export const GaSignUpBridge = () => {
  useGaSignUpOnce();
  return null;
};
